import { type GroupSummary } from '@fs/zion-tree-types'
import { type GedcomFile, type GedcomStatus } from '../services/groupTypes'

type FilteredGroups = {
  sortedFamilyGroups: GroupSummary[]
  ownedTrees: GroupSummary[]
  sharedTrees: GroupSummary[]
  processingFiles: GedcomFile[]
}

export function filterAndSortGroups(
  groups: GroupSummary[] | null | undefined,
  uploadedFiles: GedcomFile[]
): FilteredGroups {
  const allGroups = groups ?? []

  // Filter family groups (non-researcher trees)
  const familyGroups = allGroups
    .filter((group) => !group.types.includes('RESEARCHER_TREE'))
    .sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()))

  // Filter researcher tree groups
  const researcherGroups = allGroups.filter((group) => group.types.includes('RESEARCHER_TREE'))

  // Get files that are actively processing (don't have a groupId/treeId yet and have processing status)
  const processingStatuses = new Set<GedcomStatus>(['UPLOADING', 'PROCESSING', 'PROCESSED'])
  const filesWithoutGroup = uploadedFiles.filter(
    (file) => (!file.groupId || !file.treeId) && processingStatuses.has(file.fileStatus)
  )

  // Separate into owned and shared, then sort
  const owned = researcherGroups
    .filter((group) => group.memberStatus === 'ADMIN')
    .sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()))

  const shared = researcherGroups
    .filter((group) => group.memberStatus === 'MEMBER')
    .sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()))

  return {
    sortedFamilyGroups: familyGroups,
    ownedTrees: owned,
    sharedTrees: shared,
    processingFiles: filesWithoutGroup,
  }
}
